import { QualityPolicyCycle } from '../../../types/qualityPolicy';
import {
  parseDetailForm,
  parsePlanForm,
  parseReportForm,
} from '../../../utils/qualityPolicyForms';
import QualityPlanFormView from '../../quality/QualityPlanFormView';
import QualityDetailFormView from '../../quality/QualityDetailFormView';
import QualityReportFormView from '../../quality/QualityReportFormView';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/QualityPolicyPanel.css';
import '../../product/InspectionFormSheet.css';

interface Props {
  cycle: QualityPolicyCycle;
  doc: 'plan' | 'detail' | 'report';
}

const DOC_LABEL: Record<Props['doc'], string> = {
  plan: '추진 계획서',
  detail: '세부 계획서',
  report: '보고서',
};

const noop = () => undefined;

function QualityPolicyPreviewView({ cycle, doc }: Props) {
  const year = cycle.cycleYear;
  const title =
    doc === 'plan'
      ? cycle.planTitle
      : doc === 'detail'
        ? cycle.detailTitle
        : cycle.reportTitle;
  const stamp =
    doc === 'plan'
      ? {
          authorName: cycle.planAuthorName,
          reviewerName: cycle.planReviewerName,
          approverName: cycle.planApproverName,
        }
      : doc === 'detail'
        ? {
            authorName: cycle.detailAuthorName,
            reviewerName: cycle.detailReviewerName,
            approverName: cycle.detailApproverName,
          }
        : {
            authorName: cycle.reportAuthorName,
            reviewerName: cycle.reportReviewerName,
            approverName: cycle.reportApproverName,
          };

  return (
    <div className="qpolicy-editor">
      <div className="qpolicy-editor__header">
        <div>
          <h2>{DOC_LABEL[doc]}</h2>
          <p className="qpolicy-hint" style={{ margin: '4px 0 0' }}>
            {title || `${year}년 ${DOC_LABEL[doc]}`}
          </p>
        </div>
        <ApprovalStampBox
          authorName={stamp.authorName}
          reviewerName={stamp.reviewerName}
          approverName={stamp.approverName}
        />
      </div>

      <label className="qpolicy-field">
        문서 제목
        <input type="text" value={title || ''} disabled readOnly />
      </label>

      {doc === 'plan' ? (
        <QualityPlanFormView
          year={year}
          value={parsePlanForm(cycle.planContent, year)}
          disabled
          onChange={noop}
        />
      ) : null}
      {doc === 'detail' ? (
        <QualityDetailFormView
          year={year}
          value={parseDetailForm(cycle.detailContent, year)}
          disabled
          onChange={noop}
        />
      ) : null}
      {doc === 'report' ? (
        <QualityReportFormView
          year={year}
          value={parseReportForm(cycle.reportContent, year)}
          disabled
          onChange={noop}
        />
      ) : null}
    </div>
  );
}

export default QualityPolicyPreviewView;
